module.exports = Roo.locales['ar'];